import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10da060e")

_pushScopeId("data-v-10da060e")
const _hoisted_1 = { class: "nav-collapse" }
const _hoisted_2 = { class: "collapse-name" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "icon-right-open" }, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "collapse-content content-collapsed'" }, null, -1 /* HOISTED */)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", {
        class: ["name", { selected: _ctx.selected }]
      }, _toDisplayString(_ctx.name), 3 /* TEXT, CLASS */)
    ]),
    _hoisted_4
  ]))
})